var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94434 18.6296H8.74252V10.0273H5.94434V18.6296ZM16.3639 10.128C16.3343 10.1189 16.3064 10.1087 16.2751 10.1001C16.2375 10.0916 16.2 10.0842 16.1618 10.0779C16.0132 10.0483 15.8504 10.0273 15.6597 10.0273C14.028 10.0273 12.9936 11.2137 12.6526 11.672V10.0273H9.85438V18.6296H12.6526V13.9373C12.6526 13.9373 14.767 10.9922 15.6597 13.155C15.6597 15.0862 15.6597 18.629 15.6597 18.629H18.4567V12.8243C18.4567 11.5251 17.5663 10.4417 16.3639 10.128ZM7.31297 8.85447C8.06902 8.85447 8.6816 8.24186 8.6816 7.48581C8.6816 6.72976 8.06902 6.11719 7.31297 6.11719C6.55749 6.11719 5.94434 6.72976 5.94434 7.48581C5.94434 8.24186 6.55749 8.85447 7.31297 8.85447Z",
    fill: "#0077B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f7027f9dda937181b395b4013e037632.svg";
export { ForwardRef as ReactComponent };